import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';
import { cn } from '@/lib/utils';

interface BackButtonProps {
  to?: string;
  label?: string;
}

const BackButton: React.FC<BackButtonProps> = ({ 
  to = "/", 
  label = "Retour" 
}) => {
  return (
    <Link 
      to={to}
      className={cn(
        "inline-flex items-center gap-2 px-3 py-1.5",
        "text-sm text-muted-foreground",
        "rounded-lg transition-colors duration-150",
        "hover:bg-primary/10 hover:text-primary"
      )}
    >
      <ArrowLeft className="w-4 h-4" />
      <span>{label}</span>
    </Link>
  );
};

export default BackButton;
